import { render, staticRenderFns } from "../templates/cattle.pug?vue&type=template&id=8895ed06&scoped=true&lang=pug&"
import script from "./Cattle.vue?vue&type=script&lang=js&"
export * from "./Cattle.vue?vue&type=script&lang=js&"
import style0 from "./Cattle.vue?vue&type=style&index=0&id=8895ed06&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8895ed06",
  null
  
)

export default component.exports